export const constants = {
  setVideos: "SET_PRODUCTS",
  setCategories: "SET_CATEGORIES",
  filter: "FILTER",
  setHistory: "SET_HISTORY",
  addToHistory: "ADD_TO_HISTORY",
  deleteHistory: "DELETE_HISTORY",
  deleteAllHistory: "DELETE_ALL_HISTORY",
  setLikedVideos: "SET_LIKED_VIDEOS",
  addToLikedVideos: "ADD_TO_LIKED_VIDEOS",
  removeFromLikedVideos: "REMOVE_FROM_LIKED_VIDEOS",
  setWatchLater: "SET_WATCH_LATER",
  addToWatchLater: "ADD_TO_WATCH_LATER",
  removeFromWatchLater: "REMOVE_FROM_WATCH_LATER",
  setPlaylists: "SET_PLAYLISTS",
  addPlaylist: "ADD_PLAYLISTS",
  deletePlaylist: "DELETE_PLAYLISTS",
  addVideoToPlaylist: "ADD_VIDEO_TO_PLAYLIST",
  removeVideoFromPlaylist: "REMOVE_VIDEO_FROM_PLAYLIST",
  logout: "LOG_OUT",
};
